import { useEffect, useState } from 'react';
import { Button, Modal, Input, Alert, Select, Spin } from 'antd';
import { useSelector } from 'react-redux';
import _ from 'underscore';
import { useLocation } from 'react-router-dom';
import { RootState } from '../redux/store';
import { API_ENDPOINTS } from '../frameWork/utils/keyapi-endpoints';
import { useAddQuery2, useGetQuery } from '../frameWork/rest';
import AccessDenied from '../pages/error/AccessDenied';
import { Row, Col, Container } from 'react-bootstrap';
import accessDenied from '../assets/images/AccessDenied.png';
import DashLoading from './DashLoading';
import styled from 'styled-components';

const SpinContainer = styled.div`
  // text-align: center;
  // padding: 30px 50px;
  // margin-top: 30px;
  display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    //margin-bottom: 50px;
`
const Spinner = () => (
  <SpinContainer>
    <DashLoading />
  </SpinContainer>
)

interface mytype { modalOpen: boolean, setDialogOpen: any }

const ShareDashPageDialog = ({ modalOpen, setDialogOpen }: mytype) => {
  const [shareingExpireValue, setShareingExpireValue] = useState('');
  const [message, setMessage] = useState('');
  const [isSharing, setIsSharing] = useState('0');

  const [errormMessage, setErrormMessage] = useState(false);
  const [encryptInfo, setEncryptInfo] = useState('');
  const [copyCode, setCopyCode] = useState("");
  const { locationId } = useSelector((state: any) => state.DashboardPage, _.isEqual);
  const { userDetails } = useSelector((state: RootState) => ({
    userDetails: state.Auth.userDetails
  }));

  const { mutateAsync: getEnLinkInfo } = useAddQuery2(API_ENDPOINTS.PUBLIC_GENENPUBLICPAGE, "");
  const { isLoading: isloading, data: securityShare, refetch: chekUpSecurityForShare } = useGetQuery(API_ENDPOINTS.PUBLIC_PAGE, "", locationId);


  useEffect(() => {
    const d = async () => {
      await chekUpSecurityForShare()
    }
    d()
  }, [])


  useEffect(() => {
    if (securityShare)
      setIsSharing(securityShare)
  }, [securityShare])



  const CloseHandlingModal = () => {
    setDialogOpen();
  }

  const ddd = async (jsonString: any) => {
    const data = await getEnLinkInfo(jsonString);
    if (data.sanjabError === undefined) {
      const base64String = data.toString().trim().replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      setEncryptInfo(base64String)
      setErrormMessage(false)
    }
    else {
      setEncryptInfo("")
      setErrormMessage(true)
    }
  }

  const onChangeshareingExpireValue = (e: any, b: any) => {
    if (e) {
      const s_message = `لینک انتشار صفحه جاری با آدرس زیر تولید و به مدت ${b?.label} اعتبار دارد.`
      setShareingExpireValue(e)
      setMessage(s_message)
      let dateOptions: any = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      };
      let formattedDate = new Intl.DateTimeFormat('fa-IR-u-nu-latn', dateOptions).format(new Date());

      const params = {
        pId: locationId,
        uId: userDetails?.userId,
        date: formattedDate.replace(',', ''),
        exDate: e
      };

      const jsonString = JSON.stringify(params);

      ddd(jsonString)
    }
    else {
      setShareingExpireValue('')
      setMessage('')
      setCopyCode('')
      setErrormMessage(false)
      setEncryptInfo("")
    }
  }

  useEffect(() => {
    if (encryptInfo && encryptInfo !== '') {
      const d = `${window.location.origin}/dashboard/publicdashboardPage/${locationId}?data=${encryptInfo.toString().trim().replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')}`
      setCopyCode(d)
    }
  }, [encryptInfo])

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(copyCode);
    } catch (err) {
    }
  };

  return (
    <Modal
      width={750}
      style={{ position: 'relative', height: 'calc(100vh - 300px)' }}
      styles={{ body: { overflowY: 'scroll', height: 250 } }}
      zIndex={1050}
      maskClosable={false}
      destroyOnClose
      open={modalOpen}
      afterClose={CloseHandlingModal}
      title="انتشار صفحه داشبورد به صورت عمومی"
      onCancel={setDialogOpen}
      okText="ذخیره"
      cancelText="انصراف"
      footer={
        [
          <Button key="back" onClick={CloseHandlingModal}>
            انصراف
          </Button>,
        ]
      }
    >

      {isloading ? <Spinner />
        :
        isSharing === '0' ?
          <Container style={{ width: 600 }}>
            <Row className="justify-content-center">
              <Col xl={3} lg={3} xs={4}>
                <div className="text-center">
                  <div>
                    <img src={accessDenied} alt="" className="img-fluid" />
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12} className="text-center">
                {/* <h3 className="mt-3">We couldn’t connect the dots</h3> */}
                <span style={{ fontWeight: 500 }}>عدم دسترسی</span>
                <p className="text-muted mb-4 mt-2">
                  شما مجاز به اشتراک گذاری این صفحه نمی باشید
                </p>
              </Col>
            </Row>
          </Container>

          :
          <>
            <span>در صورت انتشار صفحه داشبورد، لینکی برای شما ایجاد می گردد که می توانید آن را در اختیار دیگران قرار دهید و بدون نیاز به لاگین به گزارش و نمودارهای آن صفحه دسترسی داشته باشید.</span>
            <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: 25 }}>
              <span>مدت اعتبار :</span>
              <Select
                allowClear
                defaultValue="Iran"
                value={shareingExpireValue}
                style={{ width: 120, marginRight: 10 }}
                onChange={(e, b) => onChangeshareingExpireValue(e, b)}
                options={[
                  {
                    value: '1',
                    label: 'یک ساعت',
                  },
                  {
                    value: '2',
                    label: 'یک روز',
                  },
                  {
                    value: '3',
                    label: 'یک هفته',
                  },
                  {
                    value: '4',
                    label: 'یک ماه',
                  },
                  {
                    value: '5',
                    label: 'شش ماه',
                  },
                  {
                    value: '6',
                    label: 'یک سال',
                  }
                ]}
              />
            </div>
            {copyCode != "" &&
              <div style={{
                display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'end', marginTop: 10
              }}>


                {errormMessage &&
                  <Alert style={{ width: '100%', marginTop: 10 }} message="خطایی در ساخت لینک بوجود آمد" type="error" />
                }

                {copyCode != "" &&
                  <>
                    <Alert style={{ width: '100%', marginTop: 10, color: '#4aa8ff' }} message={message} type="info" />
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: 10 }}>
                      <Button type='primary' style={{ width: 80, marginLeft: 10 }} onClick={() => handleCopyClick()}>
                        کپی لینک
                      </Button>

                      <Input
                        style={{ minWidth: 250, textAlign: 'left', width: '100%', direction: 'ltr', fontSize: 14, fontWeight: 400 }}
                        value={copyCode}
                        readOnly={true}
                      />


                    </div>
                  </>
                }


              </div>
            }
          </>
      }


    </Modal >
  );
};

export default ShareDashPageDialog;
